import angular from 'angular';
import { extend, flatten, includes, map, uniq, isEmpty, cloneDeep, every } from 'lodash';
import '../app.constants';
import '../services/organization';
import '../services/place';
import '../services/user';
import '../services/errors';
import '../services/tags-groups';
import './modals/tags-groups';
import './modals/tags-csv';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.tags', [
  'whyline.constants',
  'whyline.services.organization',
  'whyline.services.place',
  'whyline.services.user',
  'whyline.services.tags',
  'whyline.services.errors',
  'whyline.services.tags-groups',
  'whyline.modals.tags-groups',
  'whyline.modals.tags-csv',
]);

const TagsController = (
  $scope,
  OrganizationService,
  PlaceService,
  $timeout,
  ErrorService,
  $uibModal,
  TagsGroupsService,
  $translate,
) => {
  'ngInject';

  $scope.organizationId = '';
  $scope.activeTab = 1;
  $scope.tagsGroups = [];
  $scope.notResults = false;
  $scope.loaded = false;
  $scope.selectorApplyLabel = true;
  $scope.searchBox = {
    name: '',
    info: {
      address: '',
      state: '',
    },
    branchId: '',
  };

  const populatePlacesTags = () => {
    $scope.places = cloneDeep($scope.placesOriginal);
    $scope.selectAllPlace = false;
    $scope.tagsGroupsList = flatten(
      $scope.tagsGroups.map((tag) => tag.tags.map((t) => extend({ groupName: tag.name, enabled: tag.enabled, tagsGroupsId: tag._id }, t))),
    );

    $scope.activeTags = $scope.tagsGroupsList.filter((tag) => tag.enabled);
    $scope.places.map((place) => {
      place.tags = [];
      const test = $scope.tagsGroupsList.filter((tag) => includes(tag.placeIds, place._id));
      const groupsIds = uniq(test.map((tag) => tag.tagsGroupsId));
      groupsIds.map((groupId) => {
        const group = test.filter((tag) => tag.tagsGroupsId === groupId);
        const tagGroup = Object.assign({}, { groupName: group[0].groupName, tags: group });
        place.tags.push(tagGroup);
      });
    });
    $scope.placesOriginal = cloneDeep($scope.places);
    $scope.selectedTags = [];
    $scope.applyLabel = [];
    $scope.activateSelectorApplyLabel();
    filterByTagGroup();
  };

  const init = () => {
    const user = localStorage.get('user');
    $scope.superAdmin = user && user.sudo;
    const placesPromise = $scope.superAdmin
      ? PlaceService.GetAllEnterpriseAsPromise()
      : PlaceService.GetAllAsPromise();
    const organizationPromise = OrganizationService.GetCurrentAsPromise();
    const tagsGroupsPromise = TagsGroupsService.GetAllAsPromise();
    Promise.all([placesPromise, organizationPromise, tagsGroupsPromise])
      .then(([places, organization, tagsGroups]) => {
        $timeout(() => {
          $scope.organization = organization;
          $scope.organizationId = organization._id;
          $scope.tagsGroups = cloneDeep(tagsGroups);
          $scope.places = map(places, ((place) => extend({ tags: [], selectPlace: false }, place)));
          $scope.placesOriginal = cloneDeep($scope.places);
          populatePlacesTags();
          $scope.tagGroupName = tagsGroups.map((groupTag) => groupTag.name);
          $scope.loaded = true;
          $scope.selectAllPlace = false;
        });
      })
      .catch(ErrorService.handler);
  };

  $scope.tagGroupName = [];
  $scope.titleGroupTag = [];

  const filterByTagGroup = () => {
    $scope.places = cloneDeep($scope.placesOriginal);
    if (isEmpty($scope.selectedTags)) {
      return;
    }
    const placesIds = uniq(flatten($scope.selectedTags.map((tag) => tag.placeIds)));
    $scope.places = $scope.places.filter((place) => includes(placesIds, place._id));
  };

  $scope.$watch('selectedTags', filterByTagGroup, true);

  $scope.$watch('places.length', () => {
    $scope.notResults = isEmpty($scope.places);
  });

  $scope.tagsGroupsSettings = {
    template: '<translate>{{option.tagName}}</translate>',
    externalIdProp: '',
    displayProp: 'tagName',
    idProp: '_id',
    searchField: 'tagName',
    enableSearch: true,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
    showCheckAll: false,
    showUncheckAll: true,
    selectByGroups: $scope.titleGroupTag,
    groupByTextProvider: (groupValue) => {
      if (includes($scope.tagGroupName, groupValue)) {
        if (!includes($scope.titleGroupTag, groupValue)) {
          $scope.titleGroupTag.push(groupValue);
        }
        return groupValue;
      }
    },
    groupBy: 'groupName',
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('all'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    selectGroup: $translate.instant('select_all'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('search_by_tag'),
    searchPlaceholder: $translate.instant('search_tag'),
  };

  // Modal Tag Group
  $scope.openTagGroup = function (tagGroupId) {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/tags-groups-modal.html',
      size: 'lg',
      controller: 'TagsGroupsModalController',
      controllerAs: 'modal',
      resolve: {
        tagGroupId: () => tagGroupId,
      }
    });

    modal.result.then(result => {
      if (result === 'success') {
        return TagsGroupsService.GetAllAsPromise()
          .then(tagsGroups => {
            $scope.tagsGroups = tagsGroups;
            populatePlacesTags();
          })
          .catch(ErrorService.handler);
      } else {
        return;
      }
    });
  };

  $scope.deleteFilters = () => {
    $scope.selectedTags = [];
    $scope.searchBox.name = '';
    $scope.searchBox.info.address = '';
    $scope.searchBox.branchId = '';
    $scope.searchBox.info.state = '';
  };

  $scope.applyToAllPlaces = () => {
    $scope.selectAllPlace = !$scope.selectAllPlace;
    $scope.selectorApplyLabel = !$scope.selectAllPlace;
    map($scope.places, (place) => {
      place.selectPlace = $scope.selectAllPlace;
    });
  };

  $scope.onSelectPlace = (place) => {
    if (!place.selectPlace) {
      $scope.selectAllPlace = false;
    } else if (place.selectPlace && every($scope.places, 'selectPlace')) {
      $scope.selectAllPlace = true;
    }
  };

  $scope.activateSelectorApplyLabel = () => {
    const selectPlace = $scope.places.filter((place) => place.selectPlace);
    if (!selectPlace.length) {
      $scope.selectorApplyLabel = true;
    } else {
      $scope.selectorApplyLabel = false;
    }
  };

  $scope.removeTag = (tag, place) => {
    const currentPlaceId = place._id;
    const { tagsGroupsId, _id: tagId } = tag;
    const group = $scope.tagsGroups.filter((groupTags) => groupTags._id === tagsGroupsId)[0];

    group.tags.map((tag) => {
      if (tag._id === tagId) {
        const newPlacesIdes = tag.placeIds.filter((placeId) => placeId !== currentPlaceId);
        tag.placeIds = newPlacesIdes;
      }
    });

    TagsGroupsService.UpdateTags(tagsGroupsId, group.tags);
    populatePlacesTags();
  };

  $scope.applyTag = async () => {
    const selectPlace = $scope.places.filter((place) => place.selectPlace);

    if (!selectPlace.length || !$scope.applyLabel.length) {
      return;
    }

    const placesIds = selectPlace.map((place) => place._id);

    placesIds.map(placeId => {
      $scope.applyLabel.map((tag) => {
        if (!includes(tag.placeIds, placeId)) {
          tag.placeIds.push(placeId);
        }
      });
    });

    const groupsIds = uniq($scope.applyLabel.map((label) => label.tagsGroupsId));

    const promiseGroupUpdate = groupsIds.map((groupId) => {
      const group = $scope.tagsGroups.filter((label) => label._id === groupId)[0];
      return TagsGroupsService.UpdateTags(groupId, group.tags);
    });
    Promise.all(promiseGroupUpdate);
    populatePlacesTags();
  };

  $scope.switch = async function (tagGroup) {
    await TagsGroupsService.Enable(tagGroup);
    $scope.tagsGroups = await TagsGroupsService.GetAllAsPromise();
    populatePlacesTags();
  };

  // Modal CSV File
  $scope.openLoadFile = function () {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/tags-csv-modal.html',
      size: 'lg',
      controller: 'TagsCsvModalController',
      controllerAs: 'modal',
      resolve: {
        organizationId: () => $scope.organizationId,
      }
    });

    modal.result.then(result => {
      if (result === 'success') {
        return TagsGroupsService.GetAllAsPromise()
          .then(tagsGroups => {
            $scope.tagsGroups = tagsGroups;
            populatePlacesTags();
          })
          .catch(ErrorService.handler);
      } else {
        return;
      }
    });
  };

  init();
};

module.exports = module.controller('TagsController', TagsController);
